import { render, staticRenderFns } from "./OneClickOrder.vue?vue&type=template&id=06a33400&lang=pug"
import script from "./OneClickOrder.vue?vue&type=script&lang=js"
export * from "./OneClickOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports